import { render, staticRenderFns } from "./serviceFilter.vue?vue&type=template&id=196365ac"
import script from "./serviceFilter.vue?vue&type=script&lang=js"
export * from "./serviceFilter.vue?vue&type=script&lang=js"
import style0 from "./serviceFilter.vue?vue&type=style&index=0&id=196365ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports